import React, { useState, useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Protected from "./pages/Protected";
import Dashboard from "./pages/dashboard";
import KejarTugas from "./pages/kejarTugasSetting";
import LandingPageSetting from "./pages/landingPageSetting";
import Header from "./components/general/header";
import ManageUser from "./pages/ManageUser";
import "./App.css";
import { ChakraProvider } from "@chakra-ui/react";
import { createTheme } from "@mui/material/styles";
import { getIsAuthenticated } from "./services/authTokens";
import Login from "./pages/loginPage";
import OAuthCallback from "./pages/OAuthCallback";


function App() {
  const [authLoading, setAuthLoading] = useState(true);
  const [isOpen, setIsOpen] = useState(false);
  const [isTransitioning, setIsTransitioning] = useState(false);


  const theme = createTheme({
    palette: {
      mode: "light",
    },
  });

  const handleClick = () => {
    setIsTransitioning(true);
    setIsOpen(!isOpen);
    setTimeout(() => setIsTransitioning(false), 400);
  };

  useEffect(() => {
    const check = async () => {
      const ok = await getIsAuthenticated();
      setAuthLoading(false);
    };
    check();
  }, []);

  const renderWithLayout = (Component) => (
    <div className={`grid-container ${isOpen ? "sidebar-open" : "sidebar-closed"}`}>
      <Header OpenSidebar={handleClick} isOpen={isOpen} />
      <Protected Page={() => <Component />} />
    </div>
  );

  if (authLoading) {
    return (
      <ChakraProvider>
        <div style={{ height: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>Loading...</div>
      </ChakraProvider>
    );
  }

  return (
    <ChakraProvider>
      <BrowserRouter>
        <Routes>

          {/* Public Routes */}
          <Route path="/" element={<Login />} />
          <Route path="/auth/callback" element={<OAuthCallback />} />
          {/* Protected Routes (guarded by Protected component) */}
          <Route path="/dashboard" element={renderWithLayout(Dashboard)} />
          <Route path="/landing-page" element={renderWithLayout(LandingPageSetting)} />
          <Route path="/kejar-tugas" element={renderWithLayout(KejarTugas)} />
          <Route path="/manage-user" element={renderWithLayout(ManageUser)} />
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
      </BrowserRouter>
    </ChakraProvider>
  );
}

export default App;
